export const defaultRoom = _panel; //_defaultRoom;
export const doors = _doors;
export const murphybeds = _murphybeds;
export const panel = _panel;
export const tagCurateDrawers = _tagCurateDrawers;

import _defaultRoom from './test-rooms/default-room.json';
import _doors from './test-rooms/doors.json';
import _murphybeds from './test-rooms/murphybeds.json';
import _panel from './test-rooms/panel.json';
import _tagCurateDrawers from './test-rooms/tag-curate-drawers.json';
